import { createCache } from '@ant-design/cssinjs';
export const cache = createCache();